import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { DialogRef } from '../dialog-ref';
import { WindowRef } from '../../../../vendor/window/window.component';
import { ToastService } from '@core/state/toast/toast.service';
import { TranslateModule } from '@ngx-translate/core';
import { ElementsModule } from '@shared/elements/elements.module';
import { DialogBodyComponent } from '../dialog-body.component';
import { DialogActionsComponent } from '../dialog-actions.component';

@Component({
    selector: 'pay-dialog-attachment',
    templateUrl: './dialog-attachment.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        TranslateModule,
        ElementsModule,
        DialogBodyComponent,
        DialogActionsComponent
    ],
    host: {
        class: 'c-dialog attachment'
    }
})
export class DialogAttachmentComponent {
    public config: any;

    constructor(private windowRef: WindowRef,
                private toastService: ToastService,
                private dialogRef: DialogRef<DialogAttachmentComponent>) {
        this.config = dialogRef.containerInstance.config;
    }

    closeDialog() {
        this.dialogRef.close(true);
    }

    saveAttachment(event: Event) {
        if (event) {
            event.stopPropagation();
        }

        if (this.config.url) {
            const attachmentUrl: string = this.config.url.replace(/t_img_large/g, 'fl_attachment');
            this.windowRef.nativeWindow.open(attachmentUrl, '_blank');
            this.toastService.showSuccess('Common.FileDownloaded');
        }
    }
}
